import * as React from 'react';
import useAuth from '@sdk/authentication/useAuth';
import gettext from '@sdk/lang/gettext';
import { PAID_BREAKS, UNPAID_BREAKS } from '@sdk/common/constants';

import CollapsibleSettingsSection from '@web/settings/components/CollapsibleSettingsSection';
import SettingsSection from '@web/settings/components/SettingsSection';
import SettingsSwitcherRow from '@web/settings/components/SettingsSwitcherRow';
import { useUserOrgSettings } from '@web/settings/UserOrgSettingsContext';
import StandardBreaks from '@web/settings/components/schedule/BreaksV1/StandardBreaks';

const BreaksV1: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { currentUser } = useAuth();
  const { userOrgSettings, onUserOrgSettingsChange } = useUserOrgSettings();
  const { shiftBreakType } = userOrgSettings;

  const setbreaksAreEnabled = (value: boolean): void => {
    const turnedOnValue = shiftBreakType === PAID_BREAKS ? PAID_BREAKS : UNPAID_BREAKS;
    onUserOrgSettingsChange({
      shiftBreakType: value ? turnedOnValue : 0,
    });
  };

  return (
    <SettingsSection>
      <CollapsibleSettingsSection
        withSeparator
        isActive={shiftBreakType > 0}
        headerItem={
          <SettingsSwitcherRow
            disabled={!currentUser.isAdmin}
            subtitle={gettext('Enable employees to take breaks during their shifts.')}
            value={shiftBreakType > 0}
            onChange={(value: boolean): void => setbreaksAreEnabled(value)}
          />
        }
        contentItem={<StandardBreaks />}
      />
    </SettingsSection>
  );
};

export default BreaksV1;
